import l10n from "@/services/l10n";
import store from "@/store";

import { USER_GROUP_PERSON } from "@/constants";

export default ({ trackId, playlistId, active = true }) => {
  return {
    active,
    title: l10n("REMOVE_FROM_PLAYLIST"),
    icon: "delete",
    accessLevel: [USER_GROUP_PERSON],
    action() {
      if (trackId && playlistId) {
        store.dispatch("playlists/removeTrack", { trackId, playlistId });
      }
    }
  };
};
